import { render, staticRenderFns } from "./PropertyDoughnutChart.vue?vue&type=template&id=8b0f25ce"
import script from "./PropertyDoughnutChart.vue?vue&type=script&lang=js"
export * from "./PropertyDoughnutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports